import React, { useState, useRef } from 'react'
import { callAPI } from 'helpers'
import { get } from 'lodash'

// Components
import CustomModal from 'components/CustomModal'
import ExamForm from './ExamForm'
import { message } from 'antd'

export default ({ visible, classExam, onCancel, onSave }) => {
  if (!visible) return null

  const examId = get(classExam, 'classExamId')
  const examFormRef = useRef()
  const [examSaving, setExamSaving] = useState()

  const _onExamSave = async () => {
    const formData = examFormRef.current.getFormData()
    if (formData) {
      const { courseCode, title, description } = formData
      try {
        setExamSaving(true)
        const { result: savedExam } = await callAPI({
          method: 'PUT',
          url: `/exams/${examId}`,
          body: { courseCode, title, description }
        })
        setExamSaving(false)
        message.success('บันทึกข้อมูลแบบทดสอบสำเร็จ')
        onSave(savedExam)
      } catch (error) {
        console.error('Error while trying to add new exam.', error.message)
        setExamSaving(false)
        message.error('บันทึกข้อมูลแบบทดสอบไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง')
      }
    }
  }

  return (
    <CustomModal visible
      cancelText='ย้อนกลับ'
      okText='บันทึกข้อมูล'
      okButtonProps={{
        loading: examSaving,
        icon: 'save'
      }}
      onCancel={onCancel}
      onOk={_onExamSave}>
      <ExamForm
        ref={examFormRef}
        courseCode={classExam.courseCode}
        title={classExam.title}
        description={classExam.description} />
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/components/exams/ExamEditModal.js